export default __webpack_public_path__ + "static/media/PMAR_15_mos.ff403569.wav";